module.exports = __webpack_public_path__ + "static/media/acoustical.bfb53526.png";